import { required, maxLength } from "@vuelidate/validators";
import Operator from "../../models/internal/operator";
import Person from "../intranet/person";
import Sector from "../intranet/sector";
export default class Solicitation {
  constructor() {
    this.id = null;
    this.operator = new Operator();
    this.sector = new Sector();
    this.requester = new Person();
    this.description = null;
    this.priority = false;
    this.diagnose = null;
    this.status = null;
    this.date = null;
    this.avaliable = 0;
    this.url = null;
  }
  validations() {
    return {
      operator: {
        maxLength: maxLength(10),
      },
      requester: {
        maxLength: maxLength(10),
      },
      sector: {
        required,
        maxLength: maxLength(10),
      },
      description: {
        required,
      },
      priority: {
        required,
      },
      status: {
        required,
        maxLength: maxLength(50),
      },
      diagnose: {
        required,
      },
      date: {
        required,
      },
      evaluation: {
        required,
        maxLength: maxLength(10),
      },
    };
  }
}
